module.exports = __webpack_public_path__ + "static/media/ui joins.234d590e.jpg";